import React, { useState } from "react";

import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import NavigateBack from "../../components/navigateBack";

const SelectChatPage = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);

  return (
    <>
      <NavigateBack title={t("SELECT_CHAT.topHeading")} />

      <div className="body_content py-5">
        <div className="inner_body ">
          <ul className="list-unstyled list_specialist">
            <li>
              <Link
                to="/chat?admin=false"
                className={selected === "doctor" ? "active" : ""}
                onClick={() => setSelected("doctor")}
              >
                {t("SELECT_CHAT.msgDoctor")}
              </Link>
            </li>
            <li>
              <Link
                to="/chat?admin=true"
                className={selected === "receptionist" ? "active" : ""}
                onClick={() => setSelected("receptionist")}
              >
                {t("SELECT_CHAT.msgReceptionist")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SelectChatPage;
